import cn from 'clsx'
import { FC } from 'react'
import InputMask from 'react-input-mask-next'

interface IProps {
	value: string
	onChange: (value: string) => void
	disabled?: boolean
	placeholder?: string
	className?: string
}

const TimeInput: FC<IProps> = ({
	value,
	onChange,
	disabled,
	placeholder,
	className
}) => {
	return (
		<InputMask
			mask='99:99:99'
			value={value}
			onChange={e => onChange(e.target.value)}
			placeholder={placeholder || 'hh:mm:ss'}
			disabled={disabled}
		>
			<input
				className={cn(
					'rounded-xl py-[7px] pl-2 w-full text-[14px] font-normal leading-[18px] font-jetbrains outline-none bg-gray-100',
					className
				)}
			/>
		</InputMask>
	)
}

export default TimeInput
